import React from 'react'

export default function CategoryPills({ categories, selectedCategory, setSelectedCategory }) {
  if (!categories?.ids || !categories?.entities) return null

  return (
    <div className="tw-flex tw-flex-wrap tw-gap-2">
      {categories.ids.map((id) => {
        const category = categories.entities[id]
        const isSelected = selectedCategory?.id === id
        return (
          <button
            key={id}
            type="button"
            onClick={() => setSelectedCategory(category)}
            className={`tw-shrink-0 tw-rounded-full tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition-colors tw-border-2 ${
              isSelected
                ? 'tw-bg-blue-600 tw-text-white tw-border-blue-600'
                : 'tw-bg-white tw-text-slate-700 tw-border-slate-200 hover:tw-border-blue-400 hover:tw-text-blue-700'
            }`}
          >
            {category.title}
          </button>
        )
      })}
    </div>
  )
}
